import React, { useState } from "react";
import {
  Dialog,
  DialogBody,
  DialogFooter,
  DialogFooterButton,
  DialogHeader
} from "@cdk-uip/react-dialog";
import { Icon } from "@cdk-uip/react-icon";
import { Button } from "@cdk-uip/react-button";
import ContentEditable from "react-contenteditable";
import axios from "axios";
import domainURLs from "../urls";

const RatingAlert = props => {
  const [open, setOpen] = useState(true);
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [toasterMessage, setToasterMessage] = useState(false);

  const headers = {
    "x-api-key": "GQIgOomJbT9QawpdNLfT5ALieUyf5mmH6R2NZhN4",
    "Content-Type": "application/json"
  };

  const onClose = () => {
    setOpen(false);
  };
  const hideToaster = () => {
    setTimeout(() => {
      setToasterMessage(false);
    }, 5000);
  };

  const ratingClick = ele => {
    const getPreviousSiblings = (elem, filter) => {
      let sibs = [];
      while ((elem = elem.previousSibling)) {
        if (elem.nodeType === 3) continue;
        if (!filter || filter(elem)) sibs.push(elem);
      }
      return sibs;
    };
    const getNextSiblings = (elem, filter) => {
      let sibs = [];
      while ((elem = elem.nextSibling)) {
        if (elem.nodeType === 3) continue;
        if (!filter || filter(elem)) sibs.push(elem);
      }
      return sibs;
    };
    const flteration = elem => {
      switch (elem.nodeName.toUpperCase()) {
        case "INPUT":
          return true;
        default:
          return false;
      }
    };

    document.getElementsByClassName("rating-widget")[0].reset();
    setRating(ele.split("_")[1].trim());
    var prevStars = getPreviousSiblings(
      document.getElementById(ele),
      flteration
    );
    var nextStars = getNextSiblings(document.getElementById(ele), flteration);
    console.log("clicked", prevStars, nextStars);
    prevStars.forEach(item => {
      item.checked = true;
    });
    nextStars.forEach(item1 => {
      item1.checked = false;
    });

    document.getElementById(ele).checked = true;
  };
  const saveFeedback = async () => {
    // e.preventDefault();
    console.log("clicked save", rating, feedback);
    if (rating) {
      axios({
        method: "post",
        url: `${domainURLs.REACT_APP_SAVE_FEEDBACK}`,
        headers,
        data: {
          attachment_id:
            props.data &&
            props.data.data &&
            Object.keys(props.data.data)[0].trim(),
          rating,
          feedback
        }
      })
        .then(res => {
          setOpen(false);
          setToasterMessage("Thanks for feedback!");
        })
        .catch(err => {
          setToasterMessage("Failed! Please try again");
        });
      hideToaster();
    }
  };

  const resetFeedback = e => {
    e.preventDefault();
    document.getElementsByClassName("rating-widget")[0].reset();
    setFeedback("");
    setRating(0);
    console.log("clicked reset");
  };

  return (
    <div
      className={
        props.isMobile
          ? "confirmDialogMain"
          : "confirmDialogMain desktopRatingDialogMain"
      }
    >
      <Dialog open={open} onCancel={onClose}>
        <DialogBody>
          <div className="horizontalRowRatingTab" />
          <form className="rating-widget">
            <br />
            <p className="labelClassFeedback defaultTextClass">
              Please rate the watching experience:
            </p>
            <div style={{ paddingTop: "10px" }}>
              <input
                type="checkbox"
                className="star-input"
                onClick={e => {
                  ratingClick(e.target.id);
                }}
                id="rating_1"
              />
              <label className="star-input-label" htmlFor="rating_1">
                1<Icon className="cdkicon-star">cdkicon-star</Icon>
                <Icon className="cdkicon-star orange">cdkicon-star</Icon>
              </label>
              <input
                type="checkbox"
                className="star-input"
                onClick={e => {
                  ratingClick(e.target.id);
                }}
                id="rating_2"
              />
              <label className="star-input-label" htmlFor="rating_2">
                2<Icon className="cdkicon-star">cdkicon-star</Icon>
                <Icon className="cdkicon-star orange">cdkicon-star</Icon>
              </label>
              <input
                type="checkbox"
                className="star-input"
                onClick={e => {
                  ratingClick(e.target.id);
                }}
                id="rating_3"
              />
              <label className="star-input-label" htmlFor="rating_3">
                3<Icon className="cdkicon-star">cdkicon-star</Icon>
                <Icon className="cdkicon-star orange">cdkicon-star</Icon>
              </label>
              <input
                type="checkbox"
                className="star-input"
                onClick={e => {
                  ratingClick(e.target.id);
                }}
                id="rating_4"
              />
              <label className="star-input-label" htmlFor="rating_4">
                4<Icon className="cdkicon-star">cdkicon-star</Icon>
                <Icon className="cdkicon-star orange">cdkicon-star</Icon>
              </label>
              <input
                type="checkbox"
                className="star-input"
                onClick={e => {
                  ratingClick(e.target.id);
                }}
                id="rating_5"
              />
              <label className="star-input-label" htmlFor="rating_5">
                5<Icon className="cdkicon-star">cdkicon-star</Icon>
                <Icon className="cdkicon-star orange">cdkicon-star</Icon>
              </label>
            </div>
            <div>
              <br />
              <p className="labelClassFeedback defaultTextClass">
                What can be Improved?
              </p>
              <ContentEditable
                id="textarea"
                tagName="pre"
                placeholder="Type a message"
                html={feedback}
                onChange={e => setFeedback(e.target.value.trim())}
              />
            </div>
          </form>
        </DialogBody>
        <DialogFooter style={{ marginTop: "25px" }}>
          <DialogFooterButton
            onClick={onClose}
            className="defaultTextClass"
            style={{ textTransform: "capitalize" }}
          >
            Close
          </DialogFooterButton>
          <DialogFooterButton
            onClick={saveFeedback}
            className="defaultTextClass"
            style={{ textTransform: "capitalize" }}
          >
            Save
          </DialogFooterButton>
        </DialogFooter>
      </Dialog>
      {toasterMessage ? (
        <div
          className="storeview-notification-type"
          id="storeview-notification"
        >
          <p>{toasterMessage}</p>
        </div>
      ) : null}
    </div>
  );
};

export default RatingAlert;
